var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('terms-and-conditions-table',{ref:"table",attrs:{"id":"TACT1","brand-id":_vm.termsData.brandId,"current-id":_vm.termsData.current.id}})}
var staticRenderFns = []

export { render, staticRenderFns }